/// <reference types="@angular/localize" />

import '@govbr-ds/webcomponents/dist/loader';

import { bootstrapApplication } from '@angular/platform-browser';
import { appConfig } from './app/app.config';
import { App } from './app/app';
// import { environment } from './environments/environment';
// Initialize MSW in development mode
async function enableMocking() {
  // if (!environment.production) {
  //   const { worker } = await import('./mocks/browser');
  //   return worker.start();
  // }
  return Promise.resolve();
}


enableMocking().then(() => {
  bootstrapApplication(App, appConfig)
    .catch((err) => console.error(err));
});
